import * as THREE from 'three';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { downloadFile } from './downloadFile';

/**
 * Exports the given mesh as a binary .glb file that exactly matches what is
 * displayed in the viewport (same geometry instance, same material).
 */
export function exportGLB(mesh: THREE.Object3D, fileName: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const exporter = new GLTFExporter();
    exporter.parse(
      mesh,
      (result) => {
        if (result instanceof ArrayBuffer) {
          downloadFile(result, fileName, 'model/gltf-binary');
          resolve();
        } else {
          // Should not happen with binary: true, but handle defensively.
          const json = JSON.stringify(result);
          downloadFile(json, fileName.replace(/\.glb$/, '.gltf'), 'model/gltf+json');
          resolve();
        }
      },
      (error) => reject(error),
      { binary: true },
    );
  });
}
